<div class="dashboard-container">
    <h1>Suppliers Dashboard</h1>
    
    <div class="dashboard-grid">
      <mat-card (click)="navigateTo('list')" class="dashboard-card">
        <mat-card-header>
          <mat-card-title>List Supplier</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>View yearly and monthly sales comparisons</p>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
  
  
  